import styled from 'styled-components'

const StyledPostsView = styled.div`
  height: 100%;
`

export default StyledPostsView
